import { DOCUMENTS } from '../../constants/requerimentDocuments';
import { Channels } from '@/core/constants/channelConstants';

export default {
  //when channel is PR and is an update and isnt a promissory note request
  applies(context, taxRegimes) {
    return (
      context.channel === Channels.WHOLESALER &&
      context.isUpdate &&
      context.taxRegime === taxRegimes.INDIVIDUAL.value &&
      context.isPromissoryNote == 0
    );
  },
  fields() {
    return {
      [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
      [DOCUMENTS.SUBSCRIBER_ID.value]: DOCUMENTS.SUBSCRIBER_ID,
      [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
      [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
        DOCUMENTS.TAX_STATUS_CERTIFICATE,
    };
  },
};
